import styled from 'styled-components'

export const ContainerFooter = styled.footer`
    background-color: var(--background);
    width: 100vw;
    height: 80px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-around;
    justify-content: space-around;
    ul {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .icons {
        margin-right: 3rem;
    }

    svg {
        color: var(--bottom);
        font-size: 28px;
        vertical-align: middle;
    }

    div {
        color: var(--text-title);
        font-style: normal;
        font-weight: 400;
        font-size: 19px;
        line-height: 50px;
    } 

    @media(max-width: 425px) {
        .copyright {
            font-size: 14px;
        }
        svg {
            font-size: 24px;
        }
    }

    @media(max-width: 375px) {
        .icons {
            margin-right: 2rem;
        }
    }

    @media(max-width: 320px) {
        .copyright {
            font-size: 11px;
        }
    }
`